import Logo from "../common/Logo";
import Button from "../common/Button";
import StaffNav from "./StaffNav";

// Full window width with a small gutter: the staff tables carry a lot of
// columns, so they get all the room there is. The header and every page body
// use this one class, which keeps the logo and tabs on the same spot.
export const STAFF_CONTAINER = "w-full px-4 md:px-6";

// The bar across the top of every staff portal page. The logo and the tabs sit
// at the same spot on each page, so switching pages never moves them; only the
// page content below changes.
export default function StaffHeader({ onLogout }: { onLogout?: () => void }) {
  return (
    <header className="bg-base-100 border-b border-base-300">
      <div className={`${STAFF_CONTAINER} py-3 flex items-center gap-4`}>
        <Logo className="h-7" />
        <StaffNav />
        {onLogout && (
          <Button onClick={onLogout} variant="secondary" size="sm" className="ml-auto text-sm px-4">
            Logout
          </Button>
        )}
      </div>
    </header>
  );
}
